import React from "react";
import KotCard from "../kotCard/KotCard";
import "./style.css";
import { useSelector } from "react-redux";
import { NETWORK } from "../../utils/kotEnum";
import SkeletonComponent from "../skeleton/Skeleton";

const KotBody = ({ kotOrders }) => {
  const { kotOrderList, networkStatus } = useSelector(
    (state) => state.kitchenOrderTicketSlice
  );

  const list = Array.isArray(kotOrders) ? kotOrders : kotOrderList;
  return (
    <div className="kot-element-body">
      {list?.length > 0
        ? list?.map((res, i) => (
            <KotCard
              key={i}
              elementData={res}
              orderNo={res?.ordName}
              tableNo={res?.tables}
              tokenNo={res?.name}
              // tokenNo={res?.transNo}
              orderInfo={res?.orderInfo}
              status={res?.status}
              day={res?.orderDate}
            />
          ))
        : networkStatus === NETWORK.OFFLINE 
          ? <div style={{padding: '20px', textAlign: 'center', color: '#666'}}>
              📴 Offline mode - No cached orders available
            </div>
          : <SkeletonComponent />}
    </div>
  );
};

export default KotBody;
